import { AdminSliderServices } from '@/services/admin.slider.service'

const state = {
  loading: false,
  dialog: false,
  overlay: false,
  sliders: []
}
const actions = {
  setloading ({ commit }, data) {
    commit('setloading', data)
  },
  setdialog ({ commit }, diag) {
    commit('setdialog', diag)
  },
  getSlider ({ dispatch, commit }) {
    commit('setloading', true)
    AdminSliderServices.getSliders().then(value => {
      commit('setloading', false)
      commit('setsliderdata', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  addSlider ({ dispatch, commit }, postdata) {
    commit('setloading', true)
    AdminSliderServices.addSliders(postdata).then(value => {
      commit('setloading', false)
      commit('setdialog', false)
      dispatch('alert/success', 'Add Slider Ok!', { root: true })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  editSlider ({ dispatch, commit }, postdata) {
    commit('setloading', true)
    AdminSliderServices.updateSliders(postdata).then(value => {
      commit('setloading', false)
      commit('setdialog', false)
      dispatch('alert/success', 'Add Slider Ok!', { root: true })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  deleteSlider ({ dispatch, commit }, id) {
    commit('setloading', true)
    AdminSliderServices.deleteSliders(id).then(value => {
      commit('setloading', false)
      commit('setdialog', false)
      dispatch('alert/success', 'Delete Slider Ok!', { root: true })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  }
}
const mutations = {
  setloading (state, s) {
    state.loading = s
  },
  setdialog (state, s) {
    state.dialog = s
  },
  setsliderdata (state, s) {
    state.sliders = []
    state.sliders = s.data
    state.loading = false
    state.overlay = false
  }
}

export const AdminSliders = {
  namespaced: true,
  state,
  actions,
  mutations
}
